import { createWebHistory, createRouter } from "vue-router";

import Login from "./components/Login.vue";

const routes = [
  { name: "root", path: "/basic-auth/", redirect: "/basic-auth/login" },
  { name: "login", path: "/basic-auth/login", component: Login },
  {
    path: "/basic-auth/error",
    name: "errorPage",
    // lazy-loaded
    component: () => import(/* webpackChunkName: "error" */ './pages/ErrorPage.vue')
  },
];

const router = createRouter({
  mode: history,
  history: createWebHistory(),
  routes
});

//router.beforeEach((to, from, next) => {
//     const publicPages = ['/login'];
//     const authRequired = !publicPages.includes(to.path);
//
//     // trying to access a restricted page + not logged in
//     // redirect to login page
//     if (authRequired && !loggedIn) {
//         next('/login');
//     } else {
//         next();
//     }
// });

export default router;
